/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod/v4";

export const toggleContactMonitoringDtoSchema = z.object({
    "isMonitored": z.boolean().describe("Whether this contact should be synced to Radar")
    })